/* eslint-disable */
import { useState, useEffect, useRef } from 'react'
import scrollEventFn from '../scroll_event'
export default function Welfare(){
  let [employData01] = useState([
    {img : '/img/welfare_01.png', title : '사내 스낵바 운영'},
    {img : '/img/welfare_02.png', title : '생일자 상품권 지급'},
    {img : '/img/welfare_03.png', title : '휴가비 지원'},
    {img : '/img/welfare_04.png', title : '사내 동아리 활동비 지원'},
    {img : '/img/welfare_05.png', title : '명절 선물 지급'},
    {img : '/img/welfare_06.png', title : '성과급 지원'},
    {img : '/img/welfare_07.png', title : '경조사 지원'},
    {img : '/img/welfare_08.png', title : '종합건강검진지원'},
    {img : '/img/welfare_09.png', title : '중소기업 지원제도'},
    {img : '/img/welfare_10.png', title : '아낌없는 자기개발'},
  ])
  let [employData02] = useState([
    {img : '/img/welfare_11.png', title : '자유로운 연차 사용'},
    {img : '/img/welfare_12.png', title : '장기근속 포상'},
    {img : '/img/welfare_13.png', title : '임직원 리조트 회원권'},
    {img : '/img/welfare_14.png', title : '창립기념일 휴무'},
    {img : '/img/welfare_15.png', title : '근로자 휴가 지원사업'},
  ])
  let [employData03] = useState([
    {img : '/img/welfare_16.png', title : '주52시간제 준수'},
    {img : '/img/welfare_17.png', title : '휴식공간 라운지'},
    {img : '/img/welfare_18.png', title : '자유로운 회식문화'},
    {img : '/img/welfare_19.png', title : '업무능률 UP'},
    {img : '/img/welfare_20.png', title : '쾌적한 사무실'},
  ])
  // scroll event
  const scroll01 = useRef(null)
  const scroll02 = useRef(null)
  const scroll03 = useRef(null)
  const scrollArr = [
    scroll01,
    scroll02,
    scroll03,
  ]
  useEffect(() => {
    window.scrollTo({top : 0, behavior : 'smooth'})
    // scroll event
    scrollEventFn(scrollArr)
    window.addEventListener("scroll", () => {scrollEventFn(scrollArr)})
    return () => {
      window.removeEventListener("scroll", () => {scrollEventFn(scrollArr)})
    }
  }, [])
  // html
  return(
    <div className="contents">
      <div className="content-title02">복리후생</div>
      <div className="content-text01">DX손해사정은 임직원의 워라벨과 활기찬 근무환경을 제공하고 있습니다.</div>
      <div className='recruitWrap'>
        <div className="recruitTitle">Support</div>
        <div className='recruitBox scrollBox' ref={scroll01}>
          {
            employData01 && employData01.map((a, i) => (
              <div
                key={i}
                className="recruitOne"
                style={{transitionDuration : `${0.5 + Number('0.' + i)}s`}}
              >
                <div><img src={a.img} alt=""/></div>
                <p>{a.title}</p>
              </div>
            ))
          }
        </div>
        <div className="recruitTitle">Refresh</div>
        <div className='recruitBox scrollBox' ref={scroll02}>
          {
            employData02 && employData02.map((a, i) => (
              <div
                key={i}
                className="recruitOne"
                style={{transitionDuration : `${0.5 + Number('0.' + (i * 2))}s`}}
              >
                <div><img src={a.img} alt=""/></div>
                <p>{a.title}</p>
              </div>
            ))
          }
        </div>
        <div className="recruitTitle">Work-life</div>
        <div className='recruitBox scrollBox' ref={scroll03}>
          {
            employData03 && employData03.map((a, i) => (
              <div
                key={i}
                className="recruitOne"
                style={{transitionDuration : `${0.5 + Number('0.' + (i * 2))}s`}}
              >
                <div><img src={a.img} alt=""/></div>
                <p>{a.title}</p>
              </div>
            ))
          }
        </div>
      </div>
    </div>
  )
}